<div class="multiselect-container" *ngIf="filter">
    <label class="field-label typography-component-input-label ng-star-inserted">
        {{ filter.fieldName }}
    </label>
    <button
        class="multiselect-toggle"
        (click)="!isDisabled && toggleDropdown()"
        [class.multiselect-toggle--disabled]="isDisabled"
    >
        <span [class.multiselect-toggle__placeholder]="!selectedValues?.length">
            {{ placeholder }}
        </span>
        <img src="/assets/icons/arrow-down.svg" alt="" />
    </button>
    <div class="multiselect-dropdown" [hidden]="!showDropdown">
        <p class="multiselect-dropdown__title">Consult AI</p>
        <div class="multiselect-dropdown__loader" *ngIf="showLoader">
            <img src="/assets/icons/blue-loading.svg" alt="Loading" class="animation-spin" />
            <p>{{ loaderMessage }}</p>
        </div>
        <ng-container *ngIf="filter.options?.length && !showLoader; else emptyData">
            <p (click)="toggleStarterToolsDropdown()" class="multiselect-dropdown__label">
                <img
                    [src]="
                        showStarterToolsOptions
                            ? '/assets/icons/small-down-arrow.svg'
                            : '/assets/icons/small-right-arrow.svg'
                    "
                    alt="dropdown arrow"
                />
                Starter Tools
            </p>
            <ng-container *ngIf="showStarterToolsOptions">
                <div
                    id="{{ 'filterOption' + option }}"
                    class="multiselect-option"
                    [class.option-disabled]="true"
                    *ngFor="let option of liteOptions"
                >
                    <label [title]="option">
                        <input
                            type="checkbox"
                            [value]="option"
                            [checked]="isSelected(option.name)"
                            (change)="toggleSelection(option.name)"
                        />
                        {{ option.name }}
                    </label>
                </div>
            </ng-container>
            <p (click)="toggleProToolsDropwdown()" class="multiselect-dropdown__label">
                <img
                    [src]="
                        showProToolsOptions
                            ? '/assets/icons/small-down-arrow.svg'
                            : '/assets/icons/small-right-arrow.svg'
                    "
                    alt="dropdown arrow"
                />
                Pro Tools
            </p>
            <ng-container *ngIf="showProToolsOptions">
                <div
                    id="{{ 'filterOption' + option }}"
                    class="multiselect-option"
                    [class.selected]="isSelected(option.name)"
                    *ngFor="let option of proToolsOptions"
                >
                    <label [title]="option">
                        <input
                            type="checkbox"
                            [value]="option"
                            [checked]="isSelected(option.name)"
                            (change)="toggleSelection(option.name)"
                        />
                        {{ option.name }}
                    </label>
                </div>
            </ng-container>
            <hr />
            <p class="multiselect-dropdown__label">Other Platforms</p>
            <div
                id="{{ 'filterOption' + option }}"
                class="multiselect-option"
                [class.selected]="isSelected(option.name)"
                *ngFor="let option of otherToolsOptions"
            >
                <label [title]="option">
                    <input
                        type="checkbox"
                        [value]="option"
                        [checked]="isSelected(option.name)"
                        (change)="toggleSelection(option.name)"
                    />
                    {{ option.name }}
                </label>
            </div>
        </ng-container>
        <ng-template #emptyData>
            <ng-content select="[emptyData]"></ng-content>
        </ng-template>
    </div>
</div>
